import { createIcon } from '@chakra-ui/react';

export const CloseWhiteIcon = createIcon({
  displayName: 'CloseWhiteIcon',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none">
      <g opacity="0.5">
        <path
          d="M3 9.5L9 3.5M3 3.5L9 9.5"
          stroke="#FFFFFF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
});
